import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgIdealPay({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.427 4.732v14.774h10.249l3.415-.93 2.324-2.014 1.137-3.17V9.73l-1.7-2.943-2.966-1.67-2.858-.24-9.6-.145z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.98 11.998c0-2.894-1.13-7.748-8.7-7.748H3v15.532h9.28c5.61 0 8.7-2.765 8.7-7.784zM3.73 19.05V4.98h8.55c4.926 0 7.97 2.24 7.97 7.017 0 4.648-2.809 7.053-7.97 7.053H3.73z"
        fill="#0A0B09"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.908 17.932h2.737v-4.871H4.908v4.871zM7.973 10.608a1.7 1.7 0 11-3.402 0 1.7 1.7 0 013.402 0z"
        fill="#0A0B09"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.134 9.026h.788v2.377h1.168c-.32-4.313-3.714-5.245-6.797-5.245H9.005v2.87h.487c.887 0 1.438.601 1.438 1.57 0 .998-.538 1.594-1.438 1.594h-.487v5.742h3.288c5.013 0 6.758-2.328 6.82-5.742h-1.98V9.026zm-8.13.79v1.587h.488c.338 0 .65-.097.65-.806 0-.692-.348-.781-.65-.781h-.487zm6.504.976h-.57l.262-.894h.047l.26.895zm-1.8 1.4l.954-3.166h1.121l.955 3.167h-.82l-.18-.613h-1.03l-.18.613h-.82zm-.38 0v-.789h-1.161v-.433h1.04v-.788h-1.04v-.367h1.099v-.788h-1.887v3.165h1.95z"
        fill="#D50172"
      />
    </svg>
  )
}

export default SvgIdealPay
